<template>
  <el-dialog
      title="请选择产品的执行标准"
      :visible.sync="ProductNoVisible"
      :before-close="cancelModelBox"
      :close-on-click-modal="false" >
   <div>
     <el-input
       placeholder="请输入标准编号/名称进行模糊搜索"
       prefix-icon="el-icon-search"
       v-model="SearchValue" style="width: 400px;margin-bottom: 20px;">
      </el-input>
     <el-table
         :data="searchList"
         border height="350"
         style="width: 100%" @current-change="clickChange" ref="tableList">
       <el-table-column label="选择" width="55" align="center">
         <template slot-scope="scope">
           <el-radio  v-model="tableRadio" :label="scope.row"><i></i></el-radio>
         </template>
       </el-table-column>
       <el-table-column
           prop="enumCode"
           label="标准编号"
           width="180">
       </el-table-column>
       <el-table-column
           prop="enumName"
           label="标准名称">
       </el-table-column>
     </el-table>
   </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelModelBox">取 消</el-button>
      <el-button type="primary" @click="PreserveSize">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import {GetProductBatch} from "src/request/apis";
export default {
  name: "index.vue",
  props:{
    SelectId:{
      type:String,
      default:()=>''
    },
    ProductNoVisible:{
      type: Boolean,
      default: false
    },
    apiHost: {
      type: String,
      default: ''
    },
    ProductStandardNoList:{
      type: Array,
      default:()=> []
    }
  },
  watch:{
    ProductStandardNoList:{
      handler(newVal){
        console.log(newVal)
        this.tableRadio=newVal.filter(item => {
          return item.enumCode === this.SelectId
        })
      },
      deep:true
    },
    ProductNoVisible:{
      handler(newVal){
        if(newVal){
          setTimeout(()=>{
            this.rollSelectRadio(this.selectIndex)
          },100)
        }
      },
      deep:true,
      immediate:true
    },
    ChangeVal:{
      handler(newVal){
        if(newVal.list.length&&newVal.id){
          this.tableRadio=newVal.list.filter((item,index) => {
            if(item.enumCode.includes(newVal.id)){
              this.selectIndex=index
              return item
            }
          })[0]
          this.$emit('FiltrationQualityGrade', this.tableRadio);
        }

      },
      deep:true,
      immediate:true
    },
  },
  data(){
    return {
      tableRadio:'',
      SearchValue:'',
      selectIndex:0
    }
  },
  computed:{
    searchList(){
      if(!this.SearchValue){
        return this.ProductStandardNoList
      }
      return this.ProductStandardNoList.filter(v=>{
        return v.enumCode.includes(this.SearchValue) || v.enumName.includes(this.SearchValue)
      })
    },
    ChangeVal(){
      const list=this.ProductStandardNoList
      const id=this.SelectId
      return {
        list,
        id
      }
    },
  },
  created(){
  },
  methods:{
    rollSelectRadio(ind){
      document.querySelector('.el-table__body-wrapper').scrollTop=ind*48
    },
    clickChange (item) {
      this.tableRadio = item
    },
    cancelModelBox(){
      this.$emit('ChangeProductNo', false);
    },
    PreserveSize(){
      this.$emit('FiltrationQualityGrade', this.tableRadio);
      this.$emit('ChangeProductNo', false);
      this.$emit('ClearProductLevel');
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-table tr{
  font-size: 14px;
}
</style>